import React, { useState, useEffect, useCallback, useMemo } from 'react';
import './CierreTurnoModal.css';
import AuthUser from '../../../../pageauth/AuthUser';
import PuenteApi from '../../../../pageauth/PuenteApi';
import Cargando from '../../../../Cargando';
import BuscarEmpleadoModal from '../BuscarEmpleado/BuscarEmpleadoModal';
import TiradaAlBuzonModal from '../TiradaAlBuzon/TiradaAlBuzonModal';
import Swal from 'sweetalert2';

// Función utilitaria para obtener la fecha y hora actual en el formato deseado
const formatCurrentDateTime = () => {
    const now = new Date();
    const pad = (num) => String(num).padStart(2, '0');
    const year = now.getFullYear();
    const month = pad(now.getMonth() + 1); // Mes empieza en 0, así que le sumamos 1
    const day = pad(now.getDate());
    const hours = pad(now.getHours());
    const minutes = pad(now.getMinutes());
    const seconds = pad(now.getSeconds());

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};


// Definición base de todas las pestañas posibles
const BASE_TABS = [
    { id: 'declaracion', label: 'Declaracion del turno', isOptional: false },
    { id: 'bonificaciones', label: 'Bonificaciones', isOptional: false },
    { id: 'aforadoresCombustible', label: 'Aforadores Combustibles', isOptional: true },
    { id: 'aforadoresManuales', label: 'Aforadores Manuales', isOptional: true },
    { id: 'fondoFijo', label: 'Fondo Fijo', isOptional: false },
];


// ******************************************************************
// MODIFICAMOS EL COMPONENTE PARA ACEPTAR LA CONDICIÓN DE VISIBILIDAD
// ******************************************************************
const CierreTurnoModal = ({ isVisible, onClose, SetMensaje }) => {
    const { getModule, getModuleSector } = AuthUser()
    const { obtenerVentasOnline, ObtenerFechaUltimoCierreTurno, VerificarPassEmpleado, ObtenerBonificaciones, ObtenerAforadoresAutomaticos, ObtenerAforadoresManuales, CerrarTurno } = PuenteApi()
    const { StartCargando, StopCargando } = Cargando()


    const [showAforadoresManuales, setShowAforadoresManuales] = useState(false);

    // --- Lógica de Pestañas Dinámicas ---
    const getDynamicTabs = useCallback(() => {
        let tabs = BASE_TABS.filter(tab => {
            // Incluir el tab aforadoresManuales solo si la prop es true
            // if (tab.id === 'aforadoresManuales') {
            //     return showAforadoresManuales;
            // }
            return true;
        }).map((tab, index) => ({
            ...tab,
            paso: index + 1 // Reasignar el número de paso basado en las pestañas filtradas
        }));

        // Si la pestaña 'declaracion' no está presente (no debería pasar), usamos la primera.
        const defaultTabId = tabs.length > 0 ? tabs[0].id : '';

        return { tabs, defaultTabId };
    }, [showAforadoresManuales]);

    const { tabs: TABS, defaultTabId } = useMemo(getDynamicTabs, [getDynamicTabs]);

    const [activeTab, setActiveTab] = useState(defaultTabId);
    const [cierreTime, setCierreTime] = useState('');
    const [importeTarjetas, setImporteTarjetas] = useState('');
    const [apertura, setApertura] = useState('');
    const [turnoNro, setTurnoNro] = useState('');
    const [fondoFijoMonto, setFondoFijoMonto] = useState('0.00');
    const [empleadoLabel, setEmpleadoLabel] = useState('');
    const [empleado, setEmpleado] = useState('');
    const [operarioID, setOperarioID] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');
    const [showBuscarEmpleadoModal, setShowBuscarEmpleadoModal] = useState(false);
    const [contraseniaEmpleado, setContraseniaEmpleado] = useState('');
    const [aforadorIsReadOnly, setAforadorIsReadOnly] = useState(true);
    const [showTiradaModal, setShowTiradaModal] = useState(false);
    const [aforadoresAutomaticos, setAforadoresAutomaticos] = useState([]);
    const [aforadoresManuales, setAforadoresManuales] = useState([]);
    const [ERRORES, setErrores] = useState([]);
    const [bonificaciones, setBonificaciones] = useState({
        "promociones": {
            "monto": 0.00,
            "editable": true
        },
        "ventaanticipada": {
            "monto": 0.00,
            "editable": true
        },
        "bonificacion": {
            "monto": 0.00,
            "editable": true
        }
    });

    const [descMP, setDescMP] = useState('');

    const resetState = () => {
        setShowAforadoresManuales(false);
        setActiveTab(defaultTabId); // O el valor predeterminado que desees para la pestaña
        setCierreTime('');
        setImporteTarjetas('');
        setApertura('');
        setTurnoNro('');
        setFondoFijoMonto('0.00');
        setEmpleadoLabel('');
        setEmpleado('');
        setOperarioID('');
        setIsLoading(true);
        setError('');
        setShowBuscarEmpleadoModal(false);
        setContraseniaEmpleado('');
        setAforadorIsReadOnly(true);
        setShowTiradaModal(false);
        setAforadoresAutomaticos([]);
        setAforadoresManuales([]);
        setErrores([]);
        setBonificaciones({
            "promociones": {
                "monto": 0.00,
                "editable": true
            },
            "ventaanticipada": {
                "monto": 0.00,
                "editable": true
            },
            "bonificacion": {
                "monto": 0.00,
                "editable": true
            }
        });
        setDescMP('');
    };

    const verificar_empleado = async (empleado, password) => {
        const resultado = await VerificarPassEmpleado(empleado.nombre_solo, empleado.apellido_solo, empleado.id, password);
        if (resultado != true) {
            return;
        } else {
            setEmpleadoLabel(empleado.nombre);
            setEmpleado(empleado);
            setOperarioID(empleado.id);
        }
    }

    const handleSelectEmpleado = (empleado) => {
        Swal.fire({
            title: 'Ingrese su contraseña',
            input: 'password',
            inputLabel: empleado.nombre,
            inputPlaceholder: 'Ingrese su contraseña aqui...',
            showCancelButton: true,
            confirmButtonText: 'Continuar',
            cancelButtonText: 'Cancelar',
            inputValidator: (value) => {
                if (!value) {
                    return 'Necesita escribir una contraseña!';
                }
            }
        }).then((result) => {
            if (result.isConfirmed) {
                setContraseniaEmpleado(result.value);
                verificar_empleado(empleado, result.value);
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire('Operacion Cancelada', '', 'info');
            }
        });
    };

    // Sincronizar activeTab cuando las pestañas dinámicas cambian
    useEffect(() => {
        if (TABS.length > 0 && !TABS.some(tab => tab.id === activeTab)) {
            setActiveTab(TABS[0].id);
        }
        if (isVisible && !cierreTime) {
            setCierreTime(formatCurrentDateTime());
        }
    }, [isVisible, cierreTime, TABS, activeTab]);

    const agregarError = (mensaje, tipo = 'error') => {
        setErrores((prev) => [...prev, { mensaje, tipo }]);
    };

    const iniciar_valores = async () => {
        StartCargando("Obteniendo datos de cierre de turno anterior");
        const dato = await ObtenerFechaUltimoCierreTurno();
        const resultadoBonificaciones = await ObtenerBonificaciones();
        const resultadoAforadoresAutomaticos = await ObtenerAforadoresAutomaticos();
        const resultadoAforadoresManuales = await ObtenerAforadoresManuales();
        StopCargando();
        if (dato) {
            setApertura(dato.fecha);
            setTurnoNro(parseInt(dato.numero) + 1);
            StartCargando("Obteniendo datos de postnets");
            const resultado = await obtenerVentasOnline(dato.fecha);
            StopCargando();
            if (resultado) {
                if (resultado.advertencia) {
                    agregarError(resultado.advertencia, 'advertencia');
                    await Swal.fire({
                        icon: 'warning',
                        title: 'Advertencia',
                        text: 'No hubo transacciones en postnet en este turno',
                    });
                }
                setImporteTarjetas(resultado.resultado);
                setDescMP(resultado.detalle);
            } else {
                setImporteTarjetas('0.00');
                agregarError('Error al obtener ventas de postnet', 'error');
                await Swal.fire({
                    icon: 'error',
                    title: 'Error al obtener ventas de postnet',
                    text: 'Error al obtener ventas de postnet, le dara un valor de 0.00 en el campo de ventas de postnet',
                });
            }
        } else {
            setError("Error en el sistema, no se encontro datos de cierre de turno anterior");
            await Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error 2 en el sistema de gestion. NO PUEDE CONTINUAR CON ESTA OPERACION.',
            });
            onClose();
            return;
        }
        if (resultadoBonificaciones) {
            if (resultadoBonificaciones.advertencia) {
                agregarError(resultadoBonificaciones.advertencia, 'advertencia');
                await Swal.fire({
                    icon: 'warning',
                    title: 'Advertencia',
                    text: resultadoBonificaciones.advertencia,
                });
            }
            setBonificaciones(resultadoBonificaciones.data);
        } else {
            await Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error 3 en el sistema de gestion. NO PUEDE CONTINUAR CON ESTA OPERACION.',
            });
            onClose();
            return;
        }

        if (resultadoAforadoresAutomaticos) {
            if (resultadoAforadoresAutomaticos.advertencia) {
                agregarError(resultadoAforadoresAutomaticos.advertencia, 'advertencia');
                await Swal.fire({
                    icon: 'warning',
                    title: 'Advertencia',
                    text: resultadoAforadoresAutomaticos.advertencia,
                });
            }
            setAforadoresAutomaticos(resultadoAforadoresAutomaticos.surtidores);
        } else {
            await Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error 4 en el sistema de gestion. NO PUEDE CONTINUAR CON ESTA OPERACION.',
            });
            onClose();
            return;
        }
        if (resultadoAforadoresManuales) {
            setAforadoresManuales(resultadoAforadoresManuales);
        } else {
            await Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error 5 en el sistema de gestion. NO PUEDE CONTINUAR CON ESTA OPERACION.',
            });
            onClose();
            return;
        }
        setIsLoading(false);
    };

    useEffect(() => {
        if (isVisible) {
            resetState();
            iniciar_valores();
            if (getModule() == "Playa") {
                setShowAforadoresManuales(true);
            }
        }
    }, [isVisible]);

    // --- Lógica de Navegación ---
    const getTabInfo = useCallback(() => {
        const currentTabIndex = TABS.findIndex(tab => tab.id === activeTab);
        if (currentTabIndex === -1) return { pasoActualTexto: '', isLastStep: true };

        const currentStep = TABS[currentTabIndex].paso;
        const totalSteps = TABS.length;
        const currentLabel = TABS[currentTabIndex].label;

        return {
            pasoActualTexto: `Paso ${currentStep} de ${totalSteps}. ${currentLabel}`,
            isLastStep: currentTabIndex === TABS.length - 1
        };
    }, [activeTab, TABS]);

    const finalizarCierreTurno = async () => {
        const result = await CerrarTurno(
            operarioID,
            apertura,
            cierreTime,
            importeTarjetas,
            descMP,
            bonificaciones,
            aforadoresAutomaticos,
            aforadoresManuales,
            fondoFijoMonto,
            turnoNro,
        );
        if (result) {
            //Mandar a imprimir

            await Swal.fire({
                icon: 'success',
                title: 'Turno cerrado',
                text: 'Turno cerrado exitosamente',
            });
            onClose();
        } else {
            await Swal.fire({
                icon: 'error',
                title: 'Error al cerrar turno',
                text: 'Vuelva a intentarlo o informe el error al administrador',
            });
            onClose();
        }
    };

    const handleNextStep = async () => {
        const currentTabIndex = TABS.findIndex(tab => tab.id === activeTab);
        if (operarioID == '') {
            SetMensaje("Error", "Debe seleccionar un empleado", 3000);
            return;
        }
        if (currentTabIndex < TABS.length - 1) {
            setActiveTab(TABS[currentTabIndex + 1].id);
        } else {
            await finalizarCierreTurno();
        }
    };

    const handleBackStep = () => {
        const currentTabIndex = TABS.findIndex(tab => tab.id === activeTab);
        if (currentTabIndex > 0) {
            setActiveTab(TABS[currentTabIndex - 1].id);
        }
    };

    const updateMonto = (tipo, nuevoMonto) => {
        setBonificaciones(prev => {
            // Si no existe el tipo → no actualizar
            if (!prev[tipo]) return prev;

            // Si no es editable → no actualizar
            if (!prev[tipo].editable) return prev;

            return {
                ...prev,
                [tipo]: {
                    ...prev[tipo],
                    monto: nuevoMonto
                }
            };
        });
    };

    const updateFinalAutomatico = (aforadorId, nuevoMonto) => {
        setAforadoresAutomaticos(prev =>
            prev.map(aforador =>
                aforador.id === aforadorId
                    ? aforador.editable
                        ? { ...aforador, final: nuevoMonto }
                        : aforador
                    : aforador
            )
        );
    };

    const updateFinalManual = (aforadorId, nuevoMonto) => {
        setAforadoresManuales(prev =>
            prev.map(aforador =>
                aforador.id === aforadorId
                    ? aforador.editable
                        ? { ...aforador, final: nuevoMonto }
                        : aforador
                    : aforador
            )
        );
    };

    const updateCorridaAutomatico = (aforadorId, nuevoMonto) => {
        setAforadoresAutomaticos(prev =>
            prev.map(aforador => {
                // Solo modificamos si editable o GNC
                if (aforador.id === aforadorId && (aforador.editable || aforador.tipocombustible === "GNC")) {
                    return { ...aforador, corrida: nuevoMonto };
                }
                return aforador;
            })
        );
    };


    const handlePromocionesChange = (value) => {
        updateMonto('promociones', value);
    };

    const handleVentaAnticipadaChange = (value) => {
        updateMonto('ventaanticipada', value);
    };

    const handleBonificacionChange = (value) => {
        updateMonto('bonificacion', value);
    };

    const handleFinalChangeAutomatico = (aforadorId, value) => {
        updateFinalAutomatico(aforadorId, value);
    };

    const handleCorridaChangeAutomatico = (aforadorId, value) => {
        updateCorridaAutomatico(aforadorId, value);
    };

    const handleFinalChangeManual = (aforadorId, value) => {
        updateFinalManual(aforadorId, value);
    };

    // 4. Renderizado del Contenido de cada Pestaña
    const renderTabContent = () => {
        switch (activeTab) {
            case 'declaracion':
                // (Mismo contenido de Declaración del turno)
                return (
                    <div className="tab-content-declaracion">
                        <div className="input-group-cierre">
                            <label className="label-cierre">Empleado Responsable</label>
                            <div className="input-con-icono-cierre">
                                <input type="text" readOnly value={empleado.nombre} />
                                <button className="icono-btn-cierre" onClick={() => setShowBuscarEmpleadoModal(true)}>🔍</button>
                            </div>
                        </div>
                        <div className="cierre-resumen-efectivo-tarjetas">
                            <button className="boton-tirada" onClick={handleTiradasAlBuzon}>Realizar ultima tirada al buzon</button>
                            <div className="input-group-cierre tarjetas-group">
                                <label className="label-cierre">Importe de Tarjetas <span className="info-icon">ⓘ</span></label>
                                <div className="input-con-boton-cierre">
                                    <input type="text" readOnly value={importeTarjetas} className="input-black" />
                                    {/* <button className="boton-editar">Editar</button> */}
                                </div>
                            </div>
                        </div>
                    </div>
                );

            case 'bonificaciones':
                // (Mismo contenido de Declaración del turno)
                return (
                    <div className="tab-content-declaracion">

                        <div className="cierre-resumen-efectivo-tarjetas">
                            <div className="input-group-cierre tarjetas-group">
                                <label className="label-cierre">Promocion <span className="info-icon">ⓘ</span></label>
                                <div className="input-con-boton-cierre">
                                    <input type="text" readOnly={bonificaciones.promociones.edit} value={bonificaciones.promociones.monto} onChange={e => handlePromocionesChange(e.target.value)} className="input-black" />
                                </div>
                            </div>
                            <div className="input-group-cierre tarjetas-group">
                                <label className="label-cierre">Venta anticipada <span className="info-icon">ⓘ</span></label>
                                <div className="input-con-boton-cierre">
                                    <input type="text" readOnly={bonificaciones.ventaanticipada.edit} value={bonificaciones.ventaanticipada.monto} onChange={e => handleVentaAnticipadaChange(e.target.value)} className="input-black" />
                                </div>
                            </div>
                        </div>

                        <div className="cierre-resumen-efectivo-tarjetas">
                            <div className="input-group-cierre tarjetas-group">
                                <label className="label-cierre">Bonificacion <span className="info-icon">ⓘ</span></label>
                                <div className="input-con-boton-cierre">
                                    <input type="text" readOnly={bonificaciones.bonificacion.edit} value={bonificaciones.bonificacion.monto} onChange={e => handleBonificacionChange(e.target.value)} className="input-black" />
                                </div>
                            </div>
                        </div>
                    </div>
                );

            case 'aforadoresCombustible':
                // **********************************
                // CONTENIDO DE AFORADORES COMBUSTIBLE
                // **********************************
                return (
                    <div className="tab-content-aforadores">
                        <table className="aforadores-table">
                            <thead>
                                <tr className="aforadores-header">
                                    <th className="aforador-col-mang">Mang. / Combustible</th>
                                    <th>Inicial</th>
                                    <th>Corrida/Purga</th>
                                    <th>Final</th>
                                    <th>Diferencia</th>
                                </tr>
                            </thead>
                            <tbody>
                                {aforadoresAutomaticos.map((aforador) => (
                                    <tr key={aforador.id}>
                                        <td className="aforador-col-mang">{aforador.manguera}) {aforador.tipocombustible}</td>
                                        <td><input type="text" value={aforador.inicial} readOnly className="input-aforador input-black" /></td>
                                        <td><input type="text" value={aforador.corrida} readOnly={!(aforador.tipocombustible === 'GNC')} onChange={(e) => handleCorridaChangeAutomatico(aforador.id, e.target.value)} className="input-aforador" /></td>
                                        <td><input type="text" value={aforador.final} readOnly={!aforador.editable} onChange={(e) => handleFinalChangeAutomatico(aforador.id, e.target.value)} className="input-aforador input-black-light" /></td>
                                        <td><input type="text" value={(aforador.final - aforador.inicial).toFixed(2)} readOnly className="input-aforador input-black" /></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                );

            case 'aforadoresManuales':
                // **********************************
                // CONTENIDO DE AFORADORES MANUALES
                // **********************************
                return (
                    <div className="tab-content-aforadores">
                        <table className="aforadores-table">
                            <thead>
                                <tr className="aforadores-header">
                                    <th className="aforador-col-mang">TIPO</th>
                                    <th>Inicial</th>
                                    <th>Final</th>
                                    <th>Diferencia</th>
                                </tr>
                            </thead>
                            <tbody>
                                {aforadoresManuales.map((aforador) => (
                                    <tr key={aforador.id}>
                                        <td className="aforador-col-mang">{aforador.manguera}) {aforador.tipocombustible}</td>
                                        <td><input type="text" value={aforador.inicial} readOnly className="input-aforador input-black" /></td>
                                        <td><input type="text" value={aforador.final} readOnly={!aforador.editable} onChange={(e) => handleFinalChangeManual(aforador.id, e.target.value)} className="input-aforador input-black-light" /></td>
                                        <td><input type="text" value={(aforador.final - aforador.inicial).toFixed(2)} readOnly className="input-aforador input-black" /></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                );

            case 'fondoFijo':
                // (Mismo contenido de Fondo Fijo)
                return (
                    <div className="tab-content-fondo-fijo">
                        <div className="fondo-fijo-container">
                            <label className="label-fondo-fijo">Fondo fijo al comienzo del turno</label>
                            <input
                                type="text"
                                value={fondoFijoMonto}
                                onChange={(e) => setFondoFijoMonto(e.target.value)}
                                className="input-black input-fondo-fijo"
                            />
                        </div>
                    </div>
                );

            default:
                return null;
        }
    };

    const handleTiradasAlBuzon = () => {
        setShowTiradaModal(true);
    };

    const handleCloseTiradaModal = () => {
        setCierreTime(formatCurrentDateTime());
        setShowTiradaModal(false);
    };

    const cambiarpestania = (id) => {
        if (operarioID == '') {
            SetMensaje("Error", "Debe seleccionar un empleado", 3000);
            return;
        }
        setActiveTab(id);
    };

    if (!isVisible) return null;
    const { pasoActualTexto, isLastStep } = getTabInfo();

    return (
        <div className="modal-overlay-cierre">
            <BuscarEmpleadoModal
                isVisible={showBuscarEmpleadoModal}
                onClose={() => setShowBuscarEmpleadoModal(false)}
                onSelectempleado={handleSelectEmpleado}
            />
            <TiradaAlBuzonModal
                isVisible={showTiradaModal}
                onClose={handleCloseTiradaModal}
                SetMensaje={SetMensaje} // Pasamos la función de mensaje
            />
            <div className="modal-content-cierre large-content"> {/* Añadir clase large-content */}
                {/* Cabecera del Modal */}
                <div className="modal-header-cierre">
                    <div className="cierre-info-principal">
                        <h2 className="modal-title-cierre">Cierre de Turno en {getModule()} {getModuleSector()}</h2>
                        <p className="cierre-fecha">Apertura: {apertura}</p>
                        <p className="cierre-fecha">Cierre: {cierreTime}</p>
                    </div>
                    <div className="cierre-turno-nro">
                        Turno Nro: {turnoNro}
                    </div>
                </div>

                {isLoading ? (
                    <div className="cargando"> Cargando datos...</div>
                ) : (
                    error ? (
                        <div className="error"> {error}</div>
                    ) : (
                        <>
                            {/* Navegación por Pestañas */}
                            <div className="cierre-tabs-nav">
                                {TABS.map((tab) => (
                                    <button
                                        key={tab.id}
                                        className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
                                        onClick={() => cambiarpestania(tab.id)}
                                    >
                                        {tab.label}
                                    </button>
                                ))}
                            </div>

                            {/* Cuerpo del Modal (Contenido de las Pestañas) */}
                            <div className="modal-body-cierre">
                                {renderTabContent()}
                            </div>
                            {/* Pie de Página del Modal con Navegación de Pasos */}
                            <div className="modal-footer-cierre">
                                <p className="paso-actual">{pasoActualTexto}</p>
                                <div className="footer-buttons">
                                    {/* <button className="boton-paso-cancelar" onClick={onClose}>
                                        ❌ Cancelar
                                    </button> */}

                                    {activeTab !== TABS[0].id && (
                                        <button className="boton-paso-anterior" onClick={handleBackStep}>
                                            {'<'} Anterior
                                        </button>
                                    )}

                                    <button className="boton-paso-siguiente" onClick={handleNextStep}>
                                        {isLastStep ? '✅ Finalizar' : 'Siguiente >'}
                                    </button>
                                </div>
                            </div>

                            {ERRORES ? (
                                <div className="modal-footer-alertas">
                                    {ERRORES.map((notificacion, index) => {
                                        switch (notificacion.tipo) {
                                            case 'error':
                                                return (
                                                    <div key={index} className="cierre-alerta cierre-alerta-error">
                                                        ⛔ {notificacion.mensaje}
                                                    </div>
                                                );
                                            case 'advertencia':
                                                return (
                                                    <div key={index} className="cierre-alerta cierre-alerta-advertencia">
                                                        ⚠️ {notificacion.mensaje}
                                                    </div>
                                                );
                                            case 'informacion':
                                                return (
                                                    <div key={index} className="cierre-alerta cierre-alerta-informacion">
                                                        ℹ️ {notificacion.mensaje}
                                                    </div>
                                                );
                                            case 'exito':
                                                return (
                                                    <div key={index} className="cierre-alerta cierre-alerta-exito">
                                                        ✅ {notificacion.mensaje}
                                                    </div>
                                                );
                                            default:
                                                return null;
                                        }
                                    })}
                                </div>
                            ) : ''}

                        </>
                    )
                )}
            </div>
        </div>
    );
};

export default CierreTurnoModal;